var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditFillSecondary(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Edit_Fill",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.001,
    height: 20.001,
    viewBox: "0 0 20.001 20.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4409",
    "data-name": "Rectangle 4409",
    width: 20,
    height: 20,
    transform: "translate(0 0.001)",
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Edit",
    transform: "translate(0 -0.501)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4315",
    "data-name": "Path 4315",
    d: "M15.834,92.483a.833.833,0,0,0-.833.833v6.667a.834.834,0,0,1-.833.833H2.5a.834.834,0,0,1-.833-.833V88.316a.834.834,0,0,1,.833-.833H9.167a.833.833,0,0,0,0-1.667H2.5a2.5,2.5,0,0,0-2.5,2.5V99.983a2.5,2.5,0,0,0,2.5,2.5H14.167a2.5,2.5,0,0,0,2.5-2.5V93.316A.833.833,0,0,0,15.834,92.483Zm0,0",
    transform: "translate(0 -81.982)",
    fill: "grey"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4316",
    "data-name": "Path 4316",
    d: "M182.52,9.742a.422.422,0,0,0-.114.212l-.589,2.947a.416.416,0,0,0,.409.5.4.4,0,0,0,.082-.008l2.946-.589a.415.415,0,0,0,.213-.114l6.594-6.594-2.946-2.946ZM194.1,1.111a2.085,2.085,0,0,0-2.946,0L190,2.264l2.946,2.946L194.1,4.057a2.083,2.083,0,0,0,0-2.946Zm0,0",
    transform: "translate(-174.706 0)",
    fill: "grey"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditFillSecondary);
export default __webpack_public_path__ + "static/media/Edit_Fill-secondary.2dba3a5942cdc3acc0e51ddba4a89ea3.svg";
export { ForwardRef as ReactComponent };